import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import loadConfig from "@Web3WalletConfig/config";
export default {
  name: "gift",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting'])
  },
  data() {
    return {
      loadConfig,
      isLock: false,
      list: [],
      popTaskShow: false,
      modifyData: {
        "type": "0"
      },
      isLoading: false,
      isSyncLoading: false,
      selectTab: 0,
      total: 0,
      condition: {
        type: "-1",
        start_time: "",
        end_time: "",
        page: 1,
        limit: 15
      }
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let rs = await this.$http.post("/rank/activity/list", {
        status: this.selectTab == 0 ? 1 : 0,
        ...this.condition
      });
      this.isLoading = false;
      if (rs.code == 0) {
        this.list = rs.data.items;
        this.total = rs.data.total;
      }
    },
    async onSend(item) {
      this.modifyData = item;
      this.popGitfShow = true;
    },
    onReward(id) {
      this.$router.push("/rankactivityitems?id=" + id);
    },
    async onModify(item) {
      this.modifyData = item;
      this.popTaskShow = true;
    },
    onLogs(id) {
      this.$router.push("/rankactivitylogs?id=" + id);
    },
    async onSendReward(id) {
      this.isLoading = true;
      let rs = await this.$http.post("/rank/activity/award/send", {
        activity_id: id
      });
      this.isLoading = false;
      if (rs.code == 0) {
        this.$toasted.success("发放成功");
        this.getData();
      }
    },
    cutStr(str) {
      if (str) return str.replace("T", " ").replace(".000Z", "");
    },
    onRefresh() {
      this.getData();
    },
    onPageChange(e) {
      this.condition.page = e;
      this.getData();
    },
    onPageSizeChange(e) {
      this.condition.limit = e;
      this.getData();
    },
    changeDate(type, v) {
      this.condition[type] = v;
    },
    async onCreate() {
      this.modifyData = {
        "img": "",
        'status': "1",
        "type": 0,
        'start_time': '',
        'end_time': ''
      };
      this.popTaskShow = true;
    }
  },
  mounted() {
    this.getData();
  }
};